import { useSelector } from 'react-redux';
import { getProviderNew } from '../../../../utils';
import Select from '../../../Basic/Inputs/Select';

const ProviderList = ({ selectProviderId = null, onSelect = () => { }, style = {}, width = '150px', ...props }) => {

  const providers = useSelector(store => store.providers)

  return (
    <Select
      // select={getProviderNew(selectProviderId, providers)}
      select={providers.find(p => p.id === selectProviderId )}
      list={providers}
      // list={providers.filter(pr => !pr.hide)}
      valueFn={pr => pr.name}
      onSelect={pr => onSelect(pr)}
      width={width}
      style={style}
      {...props}
    />
  );
};

export default ProviderList;
